import { Suspense, useState } from 'react'
import { useMatch, useSearchParams } from 'react-router'
import { CardSkeleton } from '@/components/layout/card-skeleton'
import { LayoutPage } from '@/components/layout/page'
import { Card } from '@/components/ui/card'
import { useCompanyPath, useIdCompany, useRBAC } from '@/lib/hooks'
import { CreateRegistryCredentialSheet } from '@/routes/registry-credentials/create-registry-credential-sheet'
import { DeleteRegistryCredentialDialog } from '@/routes/registry-credentials/delete-registry-credential-dialog'
import { RegistryCredentialsTable } from '@/routes/registry-credentials/registry-credentials-table'
import { RegistryCredentialsTableSkeleton } from '@/routes/registry-credentials/registry-credentials-table/fallback'
import { RegistryCredentialsTableHeader } from '@/routes/registry-credentials/registry-credentials-table/header'

export const RegistryCredentialsPage = () => {
  const { idCompany } = useIdCompany()
  const { rbac } = useRBAC()
  const [searchParams] = useSearchParams()
  const search = searchParams.get('search') ?? ''
  const [filterTerm, setFilterTerm] = useState(search)
  const { navigateToPath } = useCompanyPath()

  rbac.company(idCompany).apps.view.ensure()

  return (
    <LayoutPage browserTitle="Registry credentials" fallback={<CardSkeleton />}>
      <Card>
        <RegistryCredentialsTableHeader
          filterTerm={filterTerm}
          setFilterTerm={setFilterTerm}
        />
        <Suspense fallback={<RegistryCredentialsTableSkeleton />}>
          <RegistryCredentialsTable filterTerm={filterTerm} />
        </Suspense>
        <CreateRegistryCredentialSheet
          isOpen={Boolean(useMatch('/registry-credentials/create'))}
          onClose={() =>
            navigateToPath({
              pathname: '/registry-credentials',
              options: { replace: true },
            })
          }
        />
        <DeleteRegistryCredentialDialog
          isOpen={Boolean(
            useMatch('/registry-credentials/delete/:idRegistryCredential')
          )}
          onClose={() =>
            navigateToPath({
              pathname: '/registry-credentials',
              options: { replace: true },
            })
          }
        />
      </Card>
    </LayoutPage>
  )
}
